export default "__VITE_ASSET__CGR_ufe4__"